import { useGetApprovalSnapshotQuery } from 'features/comments/approvalApi';

/**
 * @param {string | null} uri
 * @returns {import('models/approval.models').ApprovalSnapshot | undefined}
 */
export function useGetApprovalSnapshot(uri) {
    const results = useGetApprovalSnapshotQuery(uri, {
        skip: uri === undefined || uri === null,
    });

    return results?.currentData;
}
